function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);
    _this.state = {
      hideForward: false,
      hideBackward: true
    };
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateButtons();
    }
  }, {
    key: "updateButtons",
    value: function updateButtons() {
      var scrollLeft = this._list.scrollLeft;
      var scrollWidth = this._list.scrollWidth;
      var width = this._list.offsetWidth;
      var hideForward = scrollWidth - scrollLeft === width;
      var hideBackward = scrollLeft === 0;
      this.setState({
        hideForward: hideForward,
        hideBackward: hideBackward
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var _this$state = this.state,
          hideForward = _this$state.hideForward,
          hideBackward = _this$state.hideBackward;
      var forwardClass = classNames('carousel__control carousel__control--forward', {
        hidden: hideForward
      });
      var backwardClass = classNames('carousel__control carousel__control--backward', {
        hidden: hideBackward
      });

      var scroller = function scroller() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
        var interval = null;
        return function () {
          var initial = _this2._list.scrollLeft;
          var scroll = 0;
          var loop = 1;
          clearInterval(interval);
          interval = setInterval(function () {
            if (scroll >= threshold) {
              _this2._list.scrollLeft = forward ? initial + scroll : initial - scroll;
              clearInterval(interval);
            } else {
              scroll += 2 * loop;
              loop += 1;
              _this2._list.scrollLeft = forward ? initial + scroll : initial - scroll;
            }
          }, 20);
        };
      };

      return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
        className: "carousel"
      }, /*#__PURE__*/React.createElement("div", {
        className: "carousel__wrap",
        ref: function ref(_ref) {
          _this2._list = _ref;
        },
        onScroll: function onScroll() {
          _this2.updateButtons();
        }
      }, /*#__PURE__*/React.createElement("ul", {
        className: "carousel__list"
      }, children))), /*#__PURE__*/React.createElement("button", {
        className: backwardClass,
        onClick: scroller(false)
      }, "<"), /*#__PURE__*/React.createElement("button", {
        className: forwardClass,
        onClick: scroller(true)
      }, ">"));
    }
  }]);

  return Carousel;
}(Component);

Carousel.displayName = "Carousel";
export { Carousel as default };
Carousel.propTypes = {
  children: PropTypes.node
};